import pluralizeFunc from 'pluralize';

export function pluralize(word: string, count: number): string {
  return pluralizeFunc(word, count);
}
